import PropTypes from 'prop-types'
import React from 'react'
import BreadcrumbItem from './BreadcrumbItem'

class Breadcrumb extends React.PureComponent {
  render() {
    const {
      items,
      className,
      styleGeneral,
      styleActive,
      styleNotActive
    } = this.props

    return (
      <div
        className={className}
        itemScope
        itemType='https://schema.org/BreadcrumbList'
      >
        {items.map(
          (item, i) =>
            item.name && (
              <BreadcrumbItem
                key={i}
                position={i + 1}
                to={item.to}
                active={item.active || null}
                isLast={i === items.length - 1}
                styleGeneral={styleGeneral}
                styleActive={styleActive}
                styleNotActive={styleNotActive}
              >
                {item.name}
              </BreadcrumbItem>
            )
        )}
      </div>
    )
  }
}

Breadcrumb.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired
}

export default Breadcrumb
